import Bar from 'd3vue/components/Bar.vue'
import { keepDimensions, buildCropFunction, valueAsNumber } from '../dataFilter'
import { toArray } from '../colors'
import api from '../api'

export default {
  id: 'bar',
  label: 'Graphique en barre',
  component: Bar,
  dimensions: 1,
  multipleMeasure: () => false,
  adaptater: (data, vue) => {
    vue.buildProps({
      color: val => {
        const colors = vue.colorScheme ? toArray(vue.colorScheme) : ['rgb(198, 113, 113)', '#99c671']
        return val < 0 ? colors[0] : colors[colors.length - 1]
      }
    })
    return buildCropFunction(d => d.y, vue)(keepDimensions(1, data).map(d => {
      return {
        data: d,
        x: d.Group0Caption,
        y: valueAsNumber(d[api.measure.name(vue.measure[0])])
      }
    }).filter(d => !vue.noEmpty || d.y))
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/Bar.js